import { render, staticRenderFns } from "./ApplicationDetails.vue?vue&type=template&id=38c722a5"
import script from "./ApplicationDetails.vue?vue&type=script&lang=js"
export * from "./ApplicationDetails.vue?vue&type=script&lang=js"
import style0 from "./ApplicationDetails.vue?vue&type=style&index=0&id=38c722a5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports